import { CircularProgress, Typography } from '@mui/material'
import { commify } from 'ethers/lib/utils'
import React from 'react'
import { useBrcBalanceList } from '@/hooks/useBrcTokenBalance'
import { SupportedTicker } from '@/constants/token'

const BtcBalance = ({ tickerName }: { tickerName: SupportedTicker }) => {
  const { data: balanceList, loading: isBalanceListLoading } = useBrcBalanceList()

  if (isBalanceListLoading) return <CircularProgress size={20} />
  else if (balanceList?.[tickerName]) {
    return <Typography>{commify(Number(balanceList?.[tickerName].balance).toFixed(2))}</Typography>
  } else {
    return <Typography>0</Typography>
  }
}

export default BtcBalance
